var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_721_422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 8.00008C0.666992 8.00008 3.33366 2.66675 8.00033 2.66675C12.667 2.66675 15.3337 8.00008 15.3337 8.00008C15.3337 8.00008 12.667 13.3334 8.00033 13.3334C3.33366 13.3334 0.666992 8.00008 0.666992 8.00008Z",
    stroke: "#A3A5AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 10.0001C9.10489 10.0001 10.0003 9.10465 10.0003 8.00008C10.0003 6.89551 9.10489 6.00008 8.00033 6.00008C6.89576 6.00008 6.00033 6.89551 6.00033 8.00008C6.00033 9.10465 6.89576 10.0001 8.00033 10.0001Z",
    stroke: "#A3A5AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b7021b6944257cf8960ce38f7ad77076.svg";
export { ForwardRef as ReactComponent };